import { StripeError } from '@stripe/stripe-js';

export const MONTHLY_PLAN_DURATION = 1;
export const ANNUAL_PLAN_DURATION = 12;

export type MembershipPriceWithCoupon = {
  monthlyPriceWithDiscounts: number;
  annualPriceWithDiscounts: number;
  coupon: number;
  duration: number | null;
};

export type PaymentForm = {
  street: string;
  city: string;
  state: string;
  zipCode: string;
};

// Keys must match the `field` values in `inputFields.ts` — errors are written as
// `errors[field]`, so a casing mismatch here silently disables that field's validation.
export type PaymentErrors = {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  cardnumber: string;
  cvc: string;
  expiration: string;
};

export type PaymentMethodResult =
  | { stripePaymentMethod: { id: string }; error?: undefined }
  | { stripePaymentMethod?: undefined; error: StripeError };
